export default {
  unnamed: '(sem nome)',
  sumShort: 'soma por período',
  meanShort: 'média por período',
  total: 'Total',
  average: 'Média',
  noData: 'Sem dados nesta seleção',
  noDataPeriod: 'Sem dados'
}
